/* import __COLOCATED_TEMPLATE__ from './connected-teams-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();